document.addEventListener('click',e=>{
  const menuButton=e.target.closest('[data-menu]');
  if(menuButton){
    const nav=document.querySelector('[data-nav]');
    if(nav){
      nav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded',nav.classList.contains('open')?'true':'false');
    }
    return;
  }

  const searchToggle=e.target.closest('[data-search-toggle]');
  if(searchToggle){
    const panel=document.querySelector('[data-header-search]');
    const input=panel?.querySelector('[data-search-input]');
    if(!panel)return;
    const isOpen=!panel.hidden;
    panel.hidden=isOpen;
    searchToggle.setAttribute('aria-expanded',isOpen?'false':'true');
    if(!isOpen)setTimeout(()=>input?.focus(),30);
    return;
  }

  if(e.target.closest('[data-search-close]'))closeHeaderSearch();
});

function closeHeaderSearch(){
  const panel=document.querySelector('[data-header-search]');
  const toggle=document.querySelector('[data-search-toggle]');
  if(panel)panel.hidden=true;
  if(toggle)toggle.setAttribute('aria-expanded','false');
}

document.addEventListener('keydown',e=>{
  if(e.key==='Escape'){
    closeHeaderSearch();
    closeOrderModal();
  }
});

let searchTimer;
document.addEventListener('input',e=>{
  const input=e.target.closest('[data-search-input]');
  if(!input)return;
  clearTimeout(searchTimer);
  const query=input.value.trim();
  const panel=input.closest('[data-header-search]');
  const results=panel?.querySelector('[data-search-results]');
  if(!results)return;
  if(query.length<2){
    results.replaceChildren();
    return;
  }
  results.textContent='كنقلبو...';
  searchTimer=setTimeout(()=>loadPredictiveResults(panel,query),180);
});

async function loadPredictiveResults(panel,query){
  const results=panel.querySelector('[data-search-results]');
  const base=panel.dataset.predictiveUrl || '/search/suggest';
  const url=`${base}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`;
  try{
    const response=await fetch(url,{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Search failed');
    const data=await response.json();
    renderPredictiveProducts(results,data?.resources?.results?.products || []);
  }catch(_error){
    results.textContent='تعذر البحث دابا، عاود المحاولة.';
  }
}

function renderPredictiveProducts(container,products){
  container.replaceChildren();
  if(!products.length){
    const empty=document.createElement('div');
    empty.className='header-search__empty';
    empty.textContent='ما لقيناش هاد العطر.';
    container.appendChild(empty);
    return;
  }

  products.forEach(product=>{
    const link=document.createElement('a');
    link.className='header-search__item';
    link.href=product.url;

    const media=document.createElement('div');
    media.className='header-search__media';
    if(product.featured_image?.url){
      const img=document.createElement('img');
      img.src=product.featured_image.url;
      img.alt=product.featured_image.alt || product.title || '';
      img.loading='lazy';
      media.appendChild(img);
    }

    const info=document.createElement('div');
    info.className='header-search__info';
    const title=document.createElement('strong');
    title.textContent=product.title || '';
    info.appendChild(title);

    if(product.price){
      const price=document.createElement('span');
      price.textContent=String(product.price);
      info.appendChild(price);
    }

    const arrow=document.createElement('span');
    arrow.className='header-search__go';
    arrow.textContent='←';
    link.append(media,info,arrow);
    container.appendChild(link);
  });
}

const LUMA_OFFER_KEY='lumaTesteurOffer';
const LUMA_SELECTED_KEY='lumaTesteurSelected';
const LUMA_OFFERS={
  '1':{count:1,price:300,label:'1 TESTEUR'},
  '2':{count:2,price:500,label:'2 TESTEURS'}
};
const lumaOrderState={offer:null,selected:[]};

function validOffer(value){return Object.prototype.hasOwnProperty.call(LUMA_OFFERS,String(value))}
function readSelectedProducts(){
  try{
    const parsed=JSON.parse(sessionStorage.getItem(LUMA_SELECTED_KEY)||'[]');
    return Array.isArray(parsed)?parsed:[];
  }catch(_error){return []}
}
function saveSelectedProducts(){sessionStorage.setItem(LUMA_SELECTED_KEY,JSON.stringify(lumaOrderState.selected))}

function initOrderFlow(){
  const urlOffer=new URLSearchParams(window.location.search).get('offer');
  const storedOffer=localStorage.getItem(LUMA_OFFER_KEY);
  if(validOffer(urlOffer)){
    if(String(urlOffer)!==String(storedOffer))sessionStorage.removeItem(LUMA_SELECTED_KEY);
    lumaOrderState.offer=String(urlOffer);
    localStorage.setItem(LUMA_OFFER_KEY,lumaOrderState.offer);
  }else if(validOffer(storedOffer)){
    lumaOrderState.offer=String(storedOffer);
  }
  lumaOrderState.selected=readSelectedProducts();
  trimSelectedToOffer();
  renderOrderFlow();
}

function setOffer(offer,clearSelection=true){
  const value=String(offer);
  if(!validOffer(value))return;
  const changed=lumaOrderState.offer!==value;
  lumaOrderState.offer=value;
  localStorage.setItem(LUMA_OFFER_KEY,value);
  if(clearSelection&&changed){
    lumaOrderState.selected=[];
    saveSelectedProducts();
  }
  trimSelectedToOffer();
  renderOrderFlow();
}

function trimSelectedToOffer(){
  if(!validOffer(lumaOrderState.offer))return;
  const max=LUMA_OFFERS[lumaOrderState.offer].count;
  if(lumaOrderState.selected.length>max){
    lumaOrderState.selected=lumaOrderState.selected.slice(0,max);
    saveSelectedProducts();
  }
}

function productFromButton(button){
  return {id:String(button.dataset.productId||''),variantId:String(button.dataset.variantId||''),title:String(button.dataset.productTitle||''),image:String(button.dataset.productImage||'')};
}

function toggleProduct(button){
  if(!validOffer(lumaOrderState.offer)){
    showOrderToast('اختار العرض الأول.');
    document.querySelector('[data-collection-offer]')?.scrollIntoView({behavior:'smooth',block:'center'});
    return;
  }
  const product=productFromButton(button);
  const currentIndex=lumaOrderState.selected.findIndex(item=>item.id===product.id);
  if(currentIndex>=0){
    lumaOrderState.selected.splice(currentIndex,1);
  }else{
    const max=LUMA_OFFERS[lumaOrderState.offer].count;
    if(lumaOrderState.selected.length>=max){
      showOrderToast(max===1?'هاد العرض فيه عطر واحد فقط.':'وصلتي لجوج عطور، حيد واحد إلا بغيتي تبدلو.');
      return;
    }
    lumaOrderState.selected.push(product);
  }
  saveSelectedProducts();
  renderOrderFlow();
}

function renderProgressSteps(offer){
  const steps=document.querySelectorAll('.collection-step');
  if(!steps.length)return;
  const complete=offer&&lumaOrderState.selected.length===offer.count;
  steps.forEach((step,index)=>{
    step.classList.remove('is-current','is-complete');
    if(!offer){
      if(index===0)step.classList.add('is-current');
      return;
    }
    if(index===0)step.classList.add('is-complete');
    if(!complete&&index===1)step.classList.add('is-current');
    if(complete&&index===1)step.classList.add('is-complete');
    if(complete&&index===2)step.classList.add('is-current');
  });
}

function renderOrderFlow(){
  const offer=validOffer(lumaOrderState.offer)?LUMA_OFFERS[lumaOrderState.offer]:null;
  renderProgressSteps(offer);

  document.querySelectorAll('[data-offer-choice]').forEach(choice=>{
    const active=offer&&String(choice.dataset.offerChoice)===String(lumaOrderState.offer);
    choice.classList.toggle('is-active',Boolean(active));
    if(choice.tagName==='BUTTON')choice.setAttribute('aria-pressed',active?'true':'false');
  });

  document.querySelectorAll('[data-product-card]').forEach(card=>{
    const selected=lumaOrderState.selected.some(item=>item.id===String(card.dataset.productCard));
    card.classList.toggle('is-selected',selected);
    const button=card.querySelector('[data-select-product]');
    if(button){
      button.setAttribute('aria-pressed',selected?'true':'false');
      const label=button.querySelector('[data-select-label]');
      const icon=button.querySelector('.product-card__select-icon');
      if(label)label.textContent=selected?'مختار':'اختار';
      if(icon)icon.textContent=selected?'✓':'+';
    }
  });

  const help=document.querySelector('[data-offer-help]');
  if(help){
    if(!offer)help.textContent='اختار العرض باش تبدا تختار العطور.';
    else if(offer.count===1)help.textContent='اختار عطر واحد، ومن بعد اضغط اشتر الآن.';
    else help.textContent='اختار جوج عطور، ومن بعد اضغط اشتر الآن.';
  }

  const dock=document.querySelector('[data-order-dock]');
  if(dock){
    dock.hidden=!offer;
    document.body.classList.toggle('has-order-dock',Boolean(offer));
    const offerLabel=dock.querySelector('[data-order-offer]');
    const countLabel=dock.querySelector('[data-selection-count]');
    const selectedWrap=dock.querySelector('[data-selected-products]');
    const buyButton=dock.querySelector('[data-buy-now]');
    if(offerLabel)offerLabel.textContent=offer?`${offer.label} • ${offer.price} DH`:'اختار العرض';
    if(countLabel)countLabel.textContent=offer?`${lumaOrderState.selected.length}/${offer.count}`:'0/0';
    if(selectedWrap)renderSelectedChips(selectedWrap);
    if(buyButton)buyButton.disabled=!offer||lumaOrderState.selected.length!==offer.count;
  }
  renderOrderSummary();
}

function renderSelectedChips(container){
  container.replaceChildren();
  lumaOrderState.selected.forEach(product=>{
    const chip=document.createElement('div');
    chip.className='order-dock__chip';
    if(product.image){
      const img=document.createElement('img');
      img.src=product.image;
      img.alt=product.title;
      chip.appendChild(img);
    }
    const name=document.createElement('span');
    name.textContent=product.title;
    chip.appendChild(name);
    container.appendChild(chip);
  });
}

function openOrderModal(){
  const offer=validOffer(lumaOrderState.offer)?LUMA_OFFERS[lumaOrderState.offer]:null;
  if(!offer||lumaOrderState.selected.length!==offer.count)return;
  const modal=document.querySelector('[data-order-modal]');
  if(!modal)return;
  modal.hidden=false;
  document.body.style.overflow='hidden';
  renderOrderSummary();
  if(!window.matchMedia('(max-width: 749px)').matches){
    setTimeout(()=>modal.querySelector('input[name="full_name"]')?.focus({preventScroll:true}),40);
  }
}

function closeOrderModal(){
  const modal=document.querySelector('[data-order-modal]');
  if(modal&&!modal.hidden){modal.hidden=true;document.body.style.overflow=''}
}

function renderOrderSummary(){
  const container=document.querySelector('[data-order-summary]');
  const offer=validOffer(lumaOrderState.offer)?LUMA_OFFERS[lumaOrderState.offer]:null;
  if(!container||!offer)return;
  container.replaceChildren();
  const top=document.createElement('div');
  top.className='order-summary__top';
  const offerText=document.createElement('span');
  offerText.textContent=offer.label;
  const price=document.createElement('span');
  price.textContent=`${offer.price} DH`;
  top.append(offerText,price);
  const list=document.createElement('div');
  list.className='order-summary__products';
  lumaOrderState.selected.forEach(product=>{
    const row=document.createElement('div');
    row.className='order-summary__product';
    if(product.image){
      const img=document.createElement('img');
      img.src=product.image;
      img.alt=product.title;
      row.appendChild(img);
    }
    const name=document.createElement('span');
    name.textContent=product.title;
    row.appendChild(name);
    list.appendChild(row);
  });
  container.append(top,list);
}

function showOrderToast(message){
  document.querySelector('.order-toast')?.remove();
  const toast=document.createElement('div');
  toast.className='order-toast';
  toast.textContent=message;
  document.body.appendChild(toast);
  setTimeout(()=>toast.remove(),2200);
}

document.addEventListener('click',e=>{
  const offerChoice=e.target.closest('[data-offer-choice]');
  if(offerChoice){
    setOffer(offerChoice.dataset.offerChoice,true);
    if(offerChoice.tagName==='BUTTON')e.preventDefault();
    return;
  }
  const selectButton=e.target.closest('[data-select-product]');
  if(selectButton){e.preventDefault();toggleProduct(selectButton);return}
  if(e.target.closest('[data-buy-now]')){e.preventDefault();openOrderModal();return}
  if(e.target.closest('[data-order-modal-close]')){e.preventDefault();closeOrderModal();return}
  if(e.target.closest('[data-order-submit]')){
    e.preventDefault();
    const form=document.querySelector('[data-order-form]');
    if(form&&!form.reportValidity())return;
    const note=document.querySelector('[data-order-form-note]');
    if(note)note.hidden=false;
  }
});

document.addEventListener('DOMContentLoaded',initOrderFlow);
